import { eq } from "drizzle-orm";
import { collections, collectionItems, counterparties } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import { generateRefCode } from "@briolin/shared";

type Db = TestDb;

export async function createCollection(
  db: Db,
  input: { barberCounterpartyId: string; title: string; productIds: string[]; expiresAt?: Date },
): Promise<{ id: string; refCode: string }> {
  // shortcut: 32^8 ≈ 10^12 пространство, коллизия пренебрежима — одна генерация без ретрая;
  // если когда-нибудь всплывёт, unique-констрейнт ref_code упадёт громко → добавить ретрай-цикл.
  const refCode = generateRefCode();
  const [c] = await db.insert(collections)
    .values({
      barberCounterpartyId: input.barberCounterpartyId,
      title: input.title,
      refCode,
      expiresAt: input.expiresAt ?? null,
    })
    .returning();
  if (input.productIds.length) {
    await db.insert(collectionItems)
      .values(input.productIds.map((productId) => ({ collectionId: c.id, productId })));
  }
  return { id: c.id, refCode: c.refCode };
}

export async function getCollectionByRefCode(
  db: Db, refCode: string,
): Promise<{ id: string; barberCounterpartyId: string; status: string } | null> {
  const [c] = await db.select().from(collections).where(eq(collections.refCode, refCode));
  if (!c) return null;
  return { id: c.id, barberCounterpartyId: c.barberCounterpartyId, status: c.status };
}

export async function attributeReferral(
  db: Db, input: { newCounterpartyId: string; refCode: string },
): Promise<void> {
  const col = await getCollectionByRefCode(db, input.refCode);
  if (!col) throw new Error(`COLLECTION_NOT_FOUND: ${input.refCode}`);
  await db.update(counterparties)
    .set({ referredByCounterpartyId: col.barberCounterpartyId })
    .where(eq(counterparties.id, input.newCounterpartyId));
  await db.update(collections).set({ status: "viewed" }).where(eq(collections.id, col.id));
}
